import styled from '@emotion/styled'

import { overrideOptional } from '@emico/overrides'
import { theme } from '@emico/styles'

const TableDataCell = styled.td`
  padding: ${theme.spacing.x1}px;
  border: 1px solid ${theme.gray500};
`

export default overrideOptional(TableDataCell)
